(() => {
  const instances = new Map();

  const initialize = () => {
    instances.forEach((cleanup, section) => {
      if (!section.isConnected) {
        cleanup();
        instances.delete(section);
      }
    });

    document.querySelectorAll('.collection-category-nav-section').forEach((section) => {
      if (instances.has(section)) return;
      const scroller = section.querySelector('.collection-category-nav__scroller');
      if (!scroller) return;

      let frame;
      const positionCurrentCategory = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const currentCard = scroller.querySelector('[aria-current="page"]');
          if (!currentCard) return;
          const scrollerRect = scroller.getBoundingClientRect();
          const cardRect = currentCard.getBoundingClientRect();
          if (cardRect.left < scrollerRect.left || cardRect.right > scrollerRect.right) {
            scroller.scrollBy({
              left: (cardRect.left + cardRect.right - scrollerRect.left - scrollerRect.right) / 2,
              behavior: 'instant',
            });
          }
        });
      };

      const observer = new ResizeObserver(positionCurrentCategory);
      observer.observe(section);
      positionCurrentCategory();
      instances.set(section, () => {
        observer.disconnect();
        cancelAnimationFrame(frame);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  // The menu-source runtime can replace the rail after this script initialized.
  // Re-run the idempotent setup only when a rail was actually replaced.
  document.addEventListener('collection:navigation-changed', initialize);
  document.addEventListener('shopify:section:load', () => {
    instances.forEach((cleanup) => cleanup());
    instances.clear();
    initialize();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((cleanup, section) => {
      if (event.target.contains(section)) {
        cleanup();
        instances.delete(section);
      }
    });
  });
})();
